import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { throwError } from 'rxjs';
import { ForecastSetting } from 'src/modules/items/item.model';
import { ConfigurationService } from 'src/services/configuration.service';

@Component({
  selector: 'app-new-item-planner-account-form',
  templateUrl: './new-item-planner-account-form.component.html',
  styleUrls: ['./new-item-planner-account-form.component.scss'],
})
export class NewItemPlannerAccountFormComponent implements OnInit {
  channelList: any;
  regionList: any;
  countryList: any[];
  distributorList: any[];
  @Input() items;
  @Input() accounts;
  @Input() launchCurvesList;
  @Input() seasonlaityIndexList = [];
  seasonlaityPatternProductList = [];
  seasonlaityPatternAccountList = [];
  @Input() newItemProductGroupList = [];
  @Input() newItemProductFamilyList = [];
  @Input() newItemParentProductList = [];
  @Input() newItemAccountRegionList = [];
  @Input() newItemAccountCountryList = [];
  @Input() newItemAccountDistributorList = [];
  @Input() calendarListDropdown = [];
  @Input() accountSettingList = [];
  @Input() timeframeList = [];
  @Input() selectedItem;
  @Input() editPermission;
  @Input() viewPermission;
  @Output() resetTreeList = new EventEmitter();
  public brandList = [];
  accountSetting: any;
  accountList: any;
  dataModel: any = {};
  public gridOptions: any;
  defaultColDef: any;
  headerHeight = 45;
  public gridApi;
  public columnDefs = [
    {
      headerName: '',
      field: '',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      resizable: true,
      width: 50,
    },
    {
      headerName: 'Brand',
      field: 'brandName',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Product Group',
      field: 'productGroupName',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Product Family',
      field: 'productFamilyName',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Item',
      field: 'itemManagerName',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Forecast Start Date',
      field: 'foreCastStartDate',
      minWidth: 50,
      resizable: true,
      cellRenderer: (params) => {
        return params.value ? formatDate(params.value, 'dd MMM, y', 'en') : '';
      },
    },
    {
      headerName: 'Forecast End Date',
      field: 'foreCastEndDate',
      minWidth: 50,
      resizable: true,
      cellRenderer: (params) => {
        return params.value ? formatDate(params.value, 'dd MMM, y', 'en') : '';
      },
    },
    {
      headerName: 'Baseline Run Rate',
      field: 'baselineRunRate',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Launch Curve',
      field: 'launchCurveName',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Seasonality Index',
      field: 'seasonalityIndexName',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Seasonality Pattren Product',
      field: 'seasonalityPatternProductName',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Seasonality Pattren Account',
      field: 'seasonalityPatternAccountName',
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'Item/Account Status',
      field: 'active',
      cellRenderer: (params) => (params.data.active ? 'Active' : 'InActive'),
      minWidth: 50,
      resizable: true,
    },
    {
      headerName: 'NIP Status',
      field: 'nipActive',
      cellRenderer: (params) => (params.data.nipActive ? 'Active' : 'InActive'),
      minWidth: 50,
      resizable: true,
    },
  ];
  public modules = AllCommunityModules;
  public rowSelection = 'multiple';
  public selectedGridNodes = [];
  constructor(private config: ConfigurationService, public spinner: NgxSpinnerService) {
    this.rowSelection = 'multiple';
    this.gridOptions = {
      angularCompileHeaders: true,
      frameworkComponents: {},
      pagination: true,
      paginationAutoPageSize: true,
    };
  }

  ngOnInit(): void {
    this.getDropdowns();
  }
  onGridReady = (params) => {
    this.gridApi = params.api;
  };
  public getDropdowns = async () => {
    this.config.AccountSettingMappingChannelGetList({}).subscribe((res) => {
      this.channelList = res;
    });
    this.brandList = await this.config
      .ProductSettingMappingBrandGetList({})
      .toPromise()
      .catch((error) => throwError(error));
  };
  public onChannelChange = (channelId) => {
    this.regionList = [];
    let regionIds;
    if (this.dataModel.regionId) {
      regionIds = JSON.parse(JSON.stringify(this.accountSetting.regionId));
    }
    this.config
      .AccountSettingMappingContinentGetList({ channelId: channelId })
      .subscribe((res) => {
        const index = this.channelList.findIndex(
          (el) => el.channelId === channelId
        );
        this.channelList[index].regionIds = res.map((el) => el.continentId);
        this.regionList = [...this.regionList, ...res];
        if (this.dataModel.regionId) {
          regionIds = (this.accountSetting.regionId as any).filter((row) =>
            this.regionList.find((el) => el.regionId === row)
          );
        }
      });
    // channelId.forEach(element => {

    // });
    if (regionIds) {
      this.dataModel.regionId = regionIds;
    }
  };
  public onRegionChange = (continentId) => {
    this.countryList = [];
      this.config
        .AccountSettingMappingCountryGetList({ continentId: continentId })
        .subscribe((res) => {
          this.countryList = res;
        });
  };
  public onCountryChange = (countryId) => {
    this.distributorList = [];
      this.config
        .AccountSettingMappingDistributorGetList({ countryId: countryId })
        .subscribe((res) => {
          this.distributorList = res;
        });
  };
  public onDistributorChange = () => {
    this.accountList = this.accounts.filter(
      (x) =>
        x.distributorId == this.dataModel.distributorId &&
        x.countryId == this.dataModel.countryId &&
        x.regionId == this.dataModel.regionId &&
        x.channelId == this.dataModel.channelId
    );
  };
  createItemAccountLists() {
    if (this.dataModel.seasonalityIndexId) {
      const selectedSeasonalityIndex = this.seasonlaityIndexList.find(
        (el) => el.commonCodeValueId === this.dataModel.seasonalityIndexId
      );
      if (selectedSeasonalityIndex) {
        const itemHeirarchyValue = selectedSeasonalityIndex.value.split('/')[0];
        const accountHeirarchyValue =
          selectedSeasonalityIndex.value.split('/')[1];
        this.createProductList(itemHeirarchyValue);
        this.createAccountList(accountHeirarchyValue);
      }
    }
  }
  public createProductList = (itemHeirarchyValue) => {
    switch (itemHeirarchyValue) {
      case 'Brand': {
        this.seasonlaityPatternProductList = this.brandList;
        this.seasonlaityPatternProductList =
          this.seasonlaityPatternProductList =
            this.seasonlaityPatternProductList.map((el) => {
              return { id: el.brandId, name: el.brandName };
            });
        break;
      }
      case 'Product Group': {
        this.seasonlaityPatternProductList = this.newItemProductGroupList;
        this.seasonlaityPatternProductList =
          this.seasonlaityPatternProductList =
            this.seasonlaityPatternProductList.map((el) => {
              return { id: el.productGroupId, name: el.productGroupName };
            });
        break;
      }
      case 'Product Family': {
        this.seasonlaityPatternProductList = this.newItemProductFamilyList;
        this.seasonlaityPatternProductList =
          this.seasonlaityPatternProductList =
            this.seasonlaityPatternProductList.map((el) => {
              return { id: el.productFamilyId, name: el.productFamilyName };
            });
        break;
      }
      case 'Parent Product': {
        this.seasonlaityPatternProductList = this.newItemParentProductList;
        this.seasonlaityPatternProductList =
          this.seasonlaityPatternProductList =
            this.seasonlaityPatternProductList.map((el) => {
              return { id: el.parentProductId, name: el.parentProductName };
            });
        break;
      }
      case 'Item': {
        this.seasonlaityPatternProductList = this.items;
        this.seasonlaityPatternProductList =
          this.seasonlaityPatternProductList =
            this.seasonlaityPatternProductList.map((el) => {
              return { id: el.itemManagerId, name: el.description };
            });
        break;
      }
    }
  };
  public createAccountList = (accountHeirarchyValue) => {
    switch (accountHeirarchyValue) {
      case 'Channel': {
        this.seasonlaityPatternAccountList = this.channelList;
        this.seasonlaityPatternAccountList =
          this.seasonlaityPatternAccountList =
            this.seasonlaityPatternAccountList.map((el) => {
              return { id: el.channelId, name: el.channelName };
            });
        break;
      }
      case 'Region': {
        this.seasonlaityPatternAccountList = this.newItemAccountRegionList;
        this.seasonlaityPatternAccountList =
          this.seasonlaityPatternAccountList.map((el) => {
            return { id: el.continentId, name: el.continentName };
          });
        break;
      }
      case 'Country': {
        this.seasonlaityPatternAccountList = this.newItemAccountCountryList;
        this.seasonlaityPatternAccountList =
          this.seasonlaityPatternAccountList.map((el) => {
            return { id: el.countryId, name: el.countryName };
          });
        break;
      }
      case 'Distirbutor': {
        this.seasonlaityPatternAccountList = this.newItemAccountDistributorList;
        this.seasonlaityPatternAccountList =
          this.seasonlaityPatternAccountList.map((el) => {
            return { id: el.distributorId, name: el.distributorName };
          });
        break;
      }
      case 'Account': {
        this.seasonlaityPatternAccountList = this.accounts;
        this.seasonlaityPatternAccountList =
          this.seasonlaityPatternAccountList.map((el) => {
            return { id: el.itemAccountId, name: el.accountName };
          });
        break;
      }
    }
  };
  setValue = (selectedDropdown) => {
    switch (selectedDropdown.type) {
      case 'Timeframe': {
        this.dataModel.calendarIds = selectedDropdown.value;
        break;
      }
    }
  };
  async onSelectionChanged(event) {
    const nodes = event.api.getSelectedNodes();
    const selectedNodes = nodes.map((el) => el.data);
    this.selectedGridNodes = selectedNodes;
  }
  apply() {
    const nodes = this.gridApi.getSelectedNodes();
    this.accountSettingList.forEach((row) => {
      const seasonality = this.seasonlaityIndexList.find(
        (el) => el.commonCodeValueId === this.dataModel.seasonalityIndexId
      );
      const launchCurve = this.launchCurvesList.find(
        (el) => el.id === this.dataModel.launchCurveId
      );
      const seasonalityProdcut = this.seasonlaityPatternProductList.find(
        (el) => el.id === this.dataModel.seasonalityPatternProductId
      );
      const seasonalityAccount = this.seasonlaityPatternAccountList.find(
        (el) => el.id === this.dataModel.seasonalityPatternAccountId
      );
      if (
        this.selectedGridNodes.find(
          (r) => r.accountSettingId === row.accountSettingId
        )
      ) {
        (row.launchCurveName = launchCurve?.name || row.launchCurveName),
          (row.seasonalityIndexName =
            seasonality?.value || row.seasonalityIndexName),
          (row.seasonalityPatternProductName =
            seasonalityProdcut?.name || row.seasonalityPatternProductName),
          (row.seasonalityPatternAccountName =
            seasonalityAccount?.name || row.seasonalityPatternAccountName),
          (row.launchCurveId =
            this.dataModel.launchCurveId || row.launchCurveId),
          (row.seasonalityPatternProductId =
            this.dataModel.seasonalityPatternProductId ||
            row.seasonalityPatternProductId),
          (row.seasonalityPatternAccountId =
            this.dataModel.seasonalityPatternAccountId ||
            row.seasonalityPatternAccountId),
          (row.nipActive = this.dataModel.nipActive),
          (row.seasonalityIndexId =
            this.dataModel.seasonalityIndexId || row.seasonalityIndexId);
      }
    });
    this.gridApi.setRowData(this.accountSettingList);
    setTimeout(() => {
      const nodeIds = nodes.map((el) => el.data.accountSettingId);
      this.setSelectedItems(nodeIds);
    }, 1);
  }
  public getCalculation = () => {
    const nodes = this.gridApi.getSelectedNodes();
    let selectedAccounts = this.accountSettingList
      .filter((el) =>
        this.selectedGridNodes.find(
          (row) => row.itemManagerId === el.itemManagerId
        )
      )
      .map((el) => ({ ...el, oldAccountId: this.dataModel.oldAccountId }));
    const calendarIds = [];
    this.dataModel.calendarIds.forEach((element) => {
      element.forEach((calendarId) => {
        calendarIds.push(calendarId);
      });
    });
    const weeks = this.timeframeList
      .filter((el) => calendarIds.includes(el.calendarId))
      .map((el) => el.weekStartDate);
    var min = weeks.reduce(function (a, b) {
      return a < b ? a : b;
    });
    var max = weeks.reduce(function (a, b) {
      return a > b ? a : b;
    });
    this.config
      .GetNIPCalculation({
        accountSettings: selectedAccounts,
        weekMaxDate: max,
        weekMinDate: min,
      })
      .subscribe((res) => {
        const sellThroughSum = res
          .map((el) => el.sellThrough)
          .reduce((a, b) => a + b, 0);
        res.forEach((el) => {
          el.sellThroughPCT = el.sellThrough / sellThroughSum;
        });
        this.accountSettingList.forEach((el) => {
          const sellTH = res.find((row) => row.itemManagerId === el.itemManagerId);
          if (sellTH) {
            el.baselineRunRate =
              this.dataModel.baselineRunRate * sellTH.sellThroughPCT;
          }
        });
        this.gridApi.setRowData(this.accountSettingList);
        setTimeout(() => {
          const nodeIds = nodes.map((el) => el.data.itemManagerId);
          this.setSelectedItems(nodeIds);
        }, 1);
      });
  };
  setSelectedItems(nodeIds: Array<number>) {
    this.gridApi.forEachNode((node) => {
      if (nodeIds.includes(node.data.itemManagerId)) {
        node.setSelected(true);
      }
    });
  }
  public saveSettings() {
    const selectedAccounts = this.accountSettingList.filter((el) =>
      this.selectedGridNodes.find(
        (row) => row.itemManagerId === el.itemManagerId
      )
    );
    this.spinner.show();
    this.config
      .AccountSettingListUpdate({ accountSettings: selectedAccounts })
      .subscribe((res) => {
        this.spinner.hide();
        this.gridApi.setRowData(this.accountSettingList);
        this.dataModel = new ForecastSetting();
        this.seasonlaityPatternProductList = [];
        this.seasonlaityPatternAccountList = [];
        this.regionList = [];
        this.countryList = [];
        this.distributorList = [];
        this.accountList = [];
        this.resetTreeList.emit(true);
      }, error => {
        this.spinner.show();
      });
  }
}
